import { baseCRUDAPI } from './base';

export default class Analytic extends baseCRUDAPI {
  constructor(axiosObject) {
    super(axiosObject, 'Analytic');
  }

  add(analytic) {
    this.axiosObject.post(`${this.apiBaseName}/add`, analytic)
      .catch((error) => {
      // Silently handle the error without throwing
        // eslint-disable-next-line no-console
        console.log('Request failed:', error.response?.status, error.message);
      });
  }
}
